const visibleDomMutation = (mutationsList) => {
  const domHasVisiblyMutated = mutationsList.some((mutationRecord) => {
    switch (mutationRecord.type) {
      case 'subtree':
        return true;
      case 'attributes':
        switch (mutationRecord.attributeName) {
          case 'style':
          case 'class': {
            const targetClasses = mutationRecord.target.className;

            const isSlider = String(targetClasses).indexOf('noUi-') > -1;

            return !isSlider;
          }
          default:
            return false;
        }
      default:
        return false;
    }
  });

  if (domHasVisiblyMutated) {
    try {
      const trustedOrigins = ['https://bilweb.com', 'https://other.domainwherewehaveaniframe.com'];
      const parentOrigin = new URL(document.referrer).origin;

      if (trustedOrigins.includes(parentOrigin)) {
        window.parent.postMessage(JSON.stringify({
          type: 'contentResize',
          height: document.body.scrollHeight,
        }), parentOrigin);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to post message:', error);
    }
  }
};

const iframeHeightObserver = (opts) => {
  if (typeof window !== 'undefined') {
    const observer = new MutationObserver(visibleDomMutation);
    observer.observe(opts.ref, opts.observer);
  }
};

export default iframeHeightObserver;
